import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GuestForm from './GuestForm';
import SecretGuestForm from './SecretGuestForm';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<GuestForm />} />
          <Route path="/secretrsvp" element={<SecretGuestForm />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
